import { useMemo, Dispatch } from "react"
import { Dialog, FormInputContainer } from "@shared/primitive-components"
import { AddedFleetEntry } from "../../../../../api/fleet"
import { useManuallyResolveEntriesFields } from "./fields/useManuallyResolveEntriesFields"
import { ManuallyResolveEntriesAction } from "../manuallyResolveEntriesReducer"

export const MANAULLY_RESOLVE_ENTRY_MODAL_DATA_TEST_IDS = {
  MODAL: `manually_resolve_entry_modal_root`,
  CANCEL_BUTTON: `manually_resolve_entry_modal_cancel`,
  DONE_BUTTON: `manually_resolve_entry_modal_done`,
}

type Props = {
  index: number
  entries: ReadonlyArray<AddedFleetEntry>
  onClose: () => void
  dispatch: Dispatch<ManuallyResolveEntriesAction>
}

export const ManuallyResolveEntryModal = ({ index, entries, onClose, dispatch }: Props) => {
  const entry = useMemo(() => entries[index], [entries, index])
  const isUnresolved = useMemo(() => !entry.vehicleId, [entry])
  const { Make, Model, Fuel, Confirm } = useManuallyResolveEntriesFields(index, entries, dispatch)
  return (
    <Dialog
      title="Enter vehicle details"
      subTitle={entry.registrationNumber}
      open
      closeDialog={onClose}
      dataTestId={MANAULLY_RESOLVE_ENTRY_MODAL_DATA_TEST_IDS.MODAL}
      primaryButton={{
        action: onClose,
        text: `Done`,
        disabled: isUnresolved,
        dataTestID: MANAULLY_RESOLVE_ENTRY_MODAL_DATA_TEST_IDS.DONE_BUTTON,
      }}
      secondaryButton={{
        dataTestID: MANAULLY_RESOLVE_ENTRY_MODAL_DATA_TEST_IDS.CANCEL_BUTTON,
      }}
    >
      <FormInputContainer label="Make" inModal>
        <Make />
      </FormInputContainer>
      <FormInputContainer label="Model" inModal>
        <Model />
      </FormInputContainer>
      <FormInputContainer label="Fuel Type" inModal>
        <Fuel />
      </FormInputContainer>
      <FormInputContainer label="Confirm" inModal>
        <Confirm />
      </FormInputContainer>
    </Dialog>
  )
}
